import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import { errorAutorizacion } from "src/co/sura/inicio/modulos/inicioActions";
import {
    CONSULTAR_NOVEDADES_RESUMEN,
    CONSULTAR_NOVEDADES_RESUMEN_XLS,
    EXITO_CONSULTA_NOVEDADES_RESUMEN,
    EXITO_CONSULTA_NOVEDADES_RESUMEN_XLS,
    ERROR_CONSULTA_NOVEDADES_RESUMEN,
    ERROR_CONSULTA_NOVEDADES_RESUMEN_XLS,
    LIMPIAR_MENSAJES_ESTADO,
    exitoConsultaNovedadesResumen,
    errorConsultaNovedadesResumen,
    exitoConsultaNovedadesResumenXLS
} from "./reciboNovedadesResumenActions";
import { FiltroConsultaReciboResumen } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import fileDownload from "js-file-download";
import * as moment from "moment";
import { ResumenNovedad } from "../modelo/ConsultaNovedadesResumen";
import {
    cabeceraReporteResumenReciboSAT,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";

export const consultarNovedadesResumenEpic = action$ =>
    action$.ofType(CONSULTAR_NOVEDADES_RESUMEN)
        .mergeMap((action: any) => {

            const url = `sat/consultar-novedades-recibidas/resumen?${obtenerParametrosFiltro(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    return exitoConsultaNovedadesResumen(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultaNovedadesResumen()];
                });
        });

export const consultarNovedadesResumenXLSEpic = action$ =>
    action$.ofType(CONSULTAR_NOVEDADES_RESUMEN_XLS)
        .mergeMap((action: any) => {

            const url = `sat/consultar-novedades-recibidas/resumen?${obtenerParametrosFiltro(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    const excelBlob: Blob = construirXLS(respuesta.datosEntidad);
                    const nombreArchivo = `reporte_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                    fileDownload(
                        excelBlob,
                        nombreArchivo,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return exitoConsultaNovedadesResumenXLS();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultaNovedadesResumen()];
                });
        });

export const reciboNovedadesResumenReducer = (state =
    {
        tamanoPagina: undefined,
        paginaActual: undefined,
        paginas: undefined,
        totalRegistros: undefined,
        estadoConsultaResumen: REQUEST.NONE,
        estadoDescargaXLS: REQUEST.NONE,
        resumenNovedades: []
    }, action: AnyAction) => {

    switch (action.type) {
        case CONSULTAR_NOVEDADES_RESUMEN:
            return {
                ...state,
                estadoConsultaResumen: REQUEST.PENDING,
                resumenNovedades: [],
                paginas: 0,
                totalRegistros: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                paginaActual: action.filtro.paginaActual
            };
        case CONSULTAR_NOVEDADES_RESUMEN_XLS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.PENDING,
            };
        case EXITO_CONSULTA_NOVEDADES_RESUMEN:
            return {
                ...state,
                estadoConsultaResumen: REQUEST.SUCCESS,
                resumenNovedades: action.datosEntidad,
                paginas: action.paginas,
                totalRegistros: action.totalDatos
            };
        case EXITO_CONSULTA_NOVEDADES_RESUMEN_XLS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.SUCCESS
            };
        case ERROR_CONSULTA_NOVEDADES_RESUMEN:
            return {
                ...state,
                estadoConsultaResumen: REQUEST.ERROR,
                resumenNovedades: [],
                paginas: 0,
                totalRegistros: 0
            };
        case ERROR_CONSULTA_NOVEDADES_RESUMEN_XLS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.ERROR
            };
        case LIMPIAR_MENSAJES_ESTADO:
            return {
                ...state,
                estadoConsultaResumen: REQUEST.NONE,
                estadoDescargaXLS: REQUEST.NONE,
                resumenNovedades: [],
                tamanoPagina: undefined,
                paginaActual: undefined,
                paginas: undefined,
                totalRegistros: undefined
            };
        default:
            return state;
    }
};

const obtenerParametrosFiltro = (filtro: FiltroConsultaReciboResumen) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.dniEmpleador)    params.set('dniEmpleador', filtro.dniEmpleador);
        if (filtro.fechaInicial)    params.set('fechaInicio', filtro.fechaInicial);
        if (filtro.fechaFinal)      params.set('fechaFin', filtro.fechaFinal);
        if (filtro.servicio)        params.set('servicio', filtro.servicio.toString());
        if (filtro.codigoConsulta)  params.set('codigoConsulta', filtro.codigoConsulta.toString());
        if (filtro.consecutivoSolicitud)  params.set('consecutivoSolicitud', filtro.consecutivoSolicitud);
        if (filtro.estados) {
            filtro.estados.forEach(estado => params.append('estado', estado.toString()));
        }

        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');
    }

    return params.toString();
};

const construirXLS = (datos: Array<ResumenNovedad>) => {
    if (!datos || !datos.length)
        return;
    /*Libros a generar en el XLS*/
    const libro = 'Reporte Resumen Novedades Recibidas SAT';
    const librosXLS = [libro];

    const datosEmpresas = [];

    const validarVacio = (dato: any) => {
        return dato ? dato : '';
    };

    datos.forEach(registro => {
        datosEmpresas.push([
            { value: validarVacio(registro.consecutivo) },
            { value: validarVacio(registro.consecutivoSolicitud) },
            { value: validarVacio(registro.nombreServicio) },
            { value: validarVacio(registro.mensajeEnviadoSAT) },
            { value: validarVacio(registro.mensajeRespuestaSura) },
            { value: validarVacio(registro.estructuraValida) },
            { value: validarVacio(registro.mensajeRespuesta) },
            { value: validarVacio(registro.codigo) },
            { value: validarVacio(registro.fechaIngresaSAT) },
            { value: validarVacio(registro.fechaRespuestaSura) },
            { value: validarVacio(registro.fechaIngresa) },
            { value: validarVacio(registro.estado) }
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libro,
        cabecera: cabeceraReporteResumenReciboSAT(),
        datos: datosEmpresas,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_resumen/modulos/reciboNovedadesResumenReducers.ts